export const Button = ({ className, onClick, label }: { className: string, onClick: () => void, label: string }) => {
  return (
    <button 
      className={className}
      onClick={onClick} 
    >
      {label}
    </button>
  );
}
